import secureApi from '../../utils/secureApi';

export async function deleteNewsArticle(id: string) {
  const response = await secureApi.post<any>(
    `/api/v1/blogs/admin/news/delete/${id}`,
    {}
  );
  
  // secureApi returns response.data automatically
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  if (response && response.data) {
    return response.data; // Wrapped in data field
  }
  return response; // Fallback
}
